import type { NotificationsResponse } from '@swiftpay/shared';
import { apiFetch } from './client.js';

export const notificationsApi = {
  list: () => apiFetch<NotificationsResponse>('/api/notifications'),
  markAllSeen: () => apiFetch<{ ok: true }>('/api/notifications/seen', { method: 'POST' }),
};
